import React from 'react'
import Preloader from '../../Global/Preloader';
import Headertwo from '../../Global/Headertwo';
import Blogbred from '../../Global/Blogbred';
import Teamdetails3 from '../Mainblogdetails/Teamdetail3';
import Ctaone from '../../Global/Ctaone';
import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';

const Main = () => {
    return (    
        <>
        {/* <Preloader/> */}
            <Headertwo />
            <Blogbred title="10 Ways NRIs Can Resolve Family Disputes From Afar"/>
            <Teamdetails3/>
            {/* <Ctaone/> */}
            <Footer/>
            <BackToTop/>
        </>
    )
}
export default Main;